module.exports = __webpack_public_path__ + "static/community-min-abeb08b093e4c35c13b9d9023d4794f9.svg";